import { useState } from "react";
import Glossary from "./Glossary";

export default function Footer() {
  const [glossaryOpen, setGlossaryOpen] = useState(false);
  return (
    <>
      <footer className="footer">
        <div>
          <span className="footer-strong">Cashflow Sentinel</span> · enterprise cash intelligence ·{" "}
          <span className="muted">
            Portfolio Billing · AR &amp; Customer Risk · Net Income Forecast · Simulator · Decision Pack
          </span>
        </div>
        <div className="muted">
          <button
            type="button"
            className="footer-link"
            onClick={() => setGlossaryOpen(true)}
            aria-label="Open construction finance glossary"
          >
            Glossary
          </button>
          {" · "}
          Azure tenant · Entra ID SSO · explainable AI · &nbsp; v2026.18
        </div>
      </footer>
      <Glossary open={glossaryOpen} onClose={() => setGlossaryOpen(false)} />
    </>
  );
}
